module.exports = __webpack_public_path__ + "img/selected0-min.4111203e.png";